import { brandPath } from "@/state/brand";

/** The creative editor, optionally opened on one canvas ("9:16"). */
export function editorPath(brandId: string, creativeId: string, aspect?: string | null): string {
  return `${brandPath(brandId, `editor/${encodeURIComponent(creativeId)}`)}${aspect ? `?aspect=${encodeURIComponent(aspect)}` : ""}`;
}
